'use client';
import Slider, { Settings, CustomArrowProps } from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { cn } from '@/lib/utils';

import './styles.css';
import BlogArticleListItem from '../BlogArticlesList/Item';
import { IBlogDictionary } from '@/dictionaries/pages/blog/types';
import { TranslatedBlogArticle } from '@/types/Blog';
import useWindowSize from '@/hooks/useWindowSize';
import { useEffect, useState } from 'react';

type Props = {
  articles: TranslatedBlogArticle[];
  lang: string;
  dict: IBlogDictionary;
};

function SampleNextArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props;
  return (
    <div
      className={cn(
        'blog-fv-button blog-fa-next-button !flex items-center justify-center',
        className,
      )}
      onClick={onClick}>
      <FiChevronRight className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

function SamplePrevArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props;
  return (
    <div
      className={cn(
        'blog-fv-button blog-fa-prev-button !flex items-center justify-center',
        className,
      )}
      onClick={onClick}>
      <FiChevronLeft className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

const settings: Settings = {
  dots: false,
  infinite: false,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function BlogFeaturedArticlesCarousel({
  articles,
  dict,
  lang,
}: Props) {
  const [defaultSettings, setDefaultSettings] = useState(settings);
  const { width } = useWindowSize();

  useEffect(() => {
    if (width <= 1099 && articles.length <= 1) {
      setDefaultSettings({ ...settings, arrows: false });
    }
    if (width > 1099 && width <= 1199 && articles.length <= 3) {
      setDefaultSettings({ ...settings, arrows: false });
    }
    if (width > 1199 && articles.length <= 4) {
      setDefaultSettings({ ...settings, arrows: false });
    }
  }, []);
  return (
    <div className="blog-feature-articles-carousel w-full">
      <Slider {...defaultSettings}>
        {articles.map((article, index) => (
          <BlogArticleListItem
            key={index}
            article={article}
            lang={lang}
            readMoreLabel={dict.readMore}
            atCarousel
          />
        ))}
      </Slider>
    </div>
  );
}
